/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const IsNullTimestamp: core.serialization.ObjectSchema<
    serializers.IsNullTimestamp.Raw,
    Truvity.IsNullTimestamp
> = core.serialization.object({});

export declare namespace IsNullTimestamp {
    export interface Raw {}
}
